import React from 'react';
import { FormattedMessage } from "react-intl";

export class ReviewStars extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      selectedValue: null,
      errorMsg: null
    }
    this.isValid = this.isValid.bind(this);
    this.checkForError = this.checkForError.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  isValid () {
    const { selectedValue } = this.state;
    let errorFree = true;

    if (!selectedValue) {
      this.setState({ errorMsg: this.props.errorMsg || <FormattedMessage id="shared_components.review_stars.leave_rating" defaultMessage="Please leave a rating"/> });
      errorFree = false;
    } else {
      this.setState({ errorMsg: '' });
    }

    return errorFree;
  }

  checkForError () {
    const { errorMsg } = this.state;

    if (errorMsg) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <p className={"help-block inline-help text-danger text-left"}>{errorMsg}</p>
          </div>
        </div>
      );
    }

    return null;
  }

  handleChange (event) {
    const selectedValue = event.target.value;
    this.setState({
      selectedValue,
      errorMsg: ''
    });
    return this.props.onChangeFn(selectedValue);
  }

  render () {
    const { onChangeFn, componentRef, fullWidth = false } = this.props;
    return (
      <div id="review-2nd-block" className={fullWidth ? "col-xs-12" : "col-sm-6 col-xs-12"}>
        <div className="form-label">
          <label tabIndex="1">
            <FormattedMessage
              id='shared_components.review_stars.rate'
              defaultMessage='Rate'
            />
          </label>
        </div>
        <div id="review-stars" ref={componentRef}>
          <div className="rating">
            <input onChange={this.handleChange} type="radio" className="star_rating_input" id="star5" name="rating" value="5" />
            <label htmlFor="star5" className="icon icon-empty-star" aria-label="5 stars"/>
            <input onChange={this.handleChange} type="radio" className="star_rating_input" id="star4" name="rating" value="4" />
            <label htmlFor="star4" className="icon icon-empty-star" aria-label="4 stars"/>
            <input onChange={this.handleChange} type="radio" className="star_rating_input" id="star3" name="rating" value="3" />
            <label htmlFor="star3" className="icon icon-empty-star" aria-label="3 stars"/>
            <input onChange={this.handleChange} type="radio" className="star_rating_input" id="star2" name="rating" value="2" />
            <label htmlFor="star2" className="icon icon-empty-star" aria-label="2 stars"/>
            <input onChange={this.handleChange} type="radio" className="star_rating_input" id="star1" name="rating" value="1"/>
            <label htmlFor="star1" className="icon icon-empty-star" aria-label="1 stars"/>
          </div>
        </div>
        { this.checkForError() }
      </div>
    );
  }
}
